import { api } from '@general/ui-kit'

// The platform's two panels on every record, asked through /related like any
// other tab, so the answer — and who may see it — is the same everywhere:
//
//   platform:mail        the conversations linked to it («Comunicaciones»)
//   platform:mail-files  the files that came by email and were linked to it
const panel = id => (type, recordId, limit = 10) =>
  api.get(`/related/${encodeURIComponent(type)}/${encodeURIComponent(recordId)}/${encodeURIComponent(id)}`, { params: { limit } })

export const relatedPanel = panel('platform:mail')
export const relatedFiles = panel('platform:mail-files')
